import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";

const MyMessages = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section className="profilecontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="profileinner">
              <div className="row gx-2 gx-lg-4">
                <Sidebar />

                <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-9 col-sm-12 col-12">
                  <div className="profilerightouter">

                    <div className="chatouter">

                      {isMobile ? (
                        selectedChat ? (
                          <ChatWindow
                            chat={selectedChat}
                            onBack={() => setSelectedChat(null)}
                          />
                        ) : (
                          <ChatList
                            onSelectChat={setSelectedChat}
                            selectedChatId={null}
                          />
                        )
                      ) : (
                        <>
                          <ChatList
                            onSelectChat={setSelectedChat}
                            selectedChatId={selectedChat?.chatId}
                          />

                          {selectedChat ? (
                            <ChatWindow chat={selectedChat} />
                          ) : (
                            <div className="chatrt">
                              <div className="chatrtinner align-items-center justify-content-center">
                                <div className="nochat">
                                  <i className="fa fa-comments-o"></i>
                                  <p>Select a chat to view messages</p>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyMessages;
